import React from 'react';

const MapComponent = ({ location, zoom }) => {
    const { lat, lng } = location;

    // Google Maps embed URL without API key
    const mapSrc = `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;

    return (
        <iframe
            src={mapSrc}
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
    );
};

export default MapComponent;
